common.View.create('admin.userAccounts.CreateEdit', {

    onDOMLoad() {
        this.initDuplicateUser();
    },

	initDuplicateUser() {

        this.element.find('.btn-duplicate').click(function(e){

            e.preventDefault();

            var url = $(this).attr('href');

            Swal.fire({
              title: 'Wat is het e-mailadres voor de nieuwe gebruiker?',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Dupliceren',
              confirmButtonColor: '#55ce63',
              cancelButtonText: 'Annuleren',
              showLoaderOnConfirm: true,
              preConfirm: (email) => {

                  return new Promise(function (resolve, reject) {

                      $.post(url, {email: email}, function(response)
                      {
                            if(!response.errors)
                            {
                                return Swal.fire({
                                  type: 'success',
                                  title: 'Gebruiker is gedupliceerd',
                                  html: 'Er is een nieuwe gebruiker aangemaakt, u kunt deze nu bewerken.',
                                  confirmButtonColor: '#55ce63',
                              }).then(function(){
                                  window.location.href=response.redirect;
                                  resolve();
                              });

                            }
                            else
                            {
                                return Swal.fire({
                                  type: 'error',
                                  title: 'Oops...',
                                  text: response.errors.join(', '),
                                });

                            }
                      });

                  });

              },
              allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {

            });

        });

    },

});
